<template>
  <div class="text-xs-center">
    <div>
      <v-card-text>
        <h2 class="headline font-weight-regular text-center">
          Select Organization
        </h2>
      </v-card-text>
      <v-card-text>
        <v-list
          two-line
          style="max-height: 600px; max-width: 600px; overflow: auto"
        >
          <template v-for="(item, index) in organizations">
            <v-list-item :key="item.id" @click="setOrganization(item)">
              <v-list-item-content>
                <v-list-item-title v-html="item.name"></v-list-item-title>
                <v-list-item-subtitle
                  v-html="item.email"
                ></v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-divider
              color="white"
              v-if="index + 1 < organizations.length"
              :key="index + 100"
            ></v-divider>
          </template>
        </v-list>
      </v-card-text>
      <v-card-actions>
        <v-btn @click="login" text class="ma-0" color="pink" large block dark>
          Cancel
        </v-btn>
      </v-card-actions>
    </div>
  </div>
</template>
<script>
export default {
  name: "authentication-select-organization",
  data() {
    return {
      organizations: [],
      isLoading: true,
      noOrganization: false,
    };
  },
  async created() {
    console.log("this.$route.params", this.$route.params);
    if (this.$route.params && this.$route.params.Organizations) {
      this.organizations = this.$route.params.Organizations;
    } else {
      this.login();
    }
  },
  methods: {
    setOrganization(org) {
      console.log("selected organization", org);
      localStorage.setItem(
        `${process.env.VUE_APP_STORAGE_PREFIX}organizationId`,
        org.id
      );
      this.$router.push({ path: "/backoffice" });
    },
    login() {
      this.$router.push({ path: "/backoffice/login" });
    },
  },
};
</script>
